function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Node, mergeAttributes, textblockTypeInputRule } from '@tiptap/core';
var Heading = Node.create({
  name: 'heading',
  addOptions: function addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: 'inline*',
  group: 'block',
  defining: true,
  addAttributes: function addAttributes() {
    return {
      level: {
        default: 1,
        rendered: false
      }
    };
  },
  parseHTML: function parseHTML() {
    return this.options.levels.map(function (level) {
      return {
        tag: "h".concat(level),
        attrs: {
          level: level
        }
      };
    });
  },
  renderHTML: function renderHTML(_ref) {
    var node = _ref.node,
      HTMLAttributes = _ref.HTMLAttributes;
    var hasLevel = this.options.levels.includes(node.attrs.level);
    var level = hasLevel ? node.attrs.level : this.options.levels[0];
    return ["h".concat(level), mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;
    return {
      setHeading: function setHeading(attributes) {
        return function (_ref2) {
          var commands = _ref2.commands;
          if (!_this.options.levels.includes(attributes.level)) {
            return false;
          }
          return commands.setNode(_this.name, attributes);
        };
      },
      toggleHeading: function toggleHeading(attributes) {
        return function (_ref3) {
          var commands = _ref3.commands;
          if (!_this.options.levels.includes(attributes.level)) {
            return false;
          }
          return commands.toggleNode(_this.name, 'paragraph', attributes);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;
    return this.options.levels.reduce(function (items, level) {
      return _objectSpread(_objectSpread({}, items), _defineProperty({}, "Mod-Alt-".concat(level), function ModAlt() {
        return _this2.editor.commands.toggleHeading({
          level: level
        });
      }));
    }, {});
  },
  addInputRules: function addInputRules() {
    var _this3 = this;
    return this.options.levels.map(function (level) {
      return textblockTypeInputRule({
        find: new RegExp("^(#{1,".concat(level, "})\\s$")),
        type: _this3.type,
        getAttributes: {
          level: level
        }
      });
    });
  }
});
export { Heading, Heading as default };